import { UploadOutlined } from '@ant-design/icons';
import { Button, Form, Upload } from 'antd';
import { THUMBNAIL_UPLOAD_STATE } from 'constants/constant';
import { seasonService } from 'content/service';
import React, { useEffect, useState } from 'react';
import { PosterInterface } from 'type/seasonType';
import PosterHandlers from '../../handlers/PosterHandlers';
import './Poster.css';
import PosterListComponent from './PosterList';

interface PosterProps {
  seasonId: number;
}

const Poster: React.FC<PosterProps> = ({ seasonId }) => {
  const [form] = Form.useForm();
  const [newPosterList, setNewPosterList] = useState<PosterInterface[]>([]);
  const [uploadedPosterList, setUploadedPosterList] = useState<PosterInterface[]>([]);
  const [selectedPoster, setSelectedPoster] = useState<PosterInterface | null>(null);
  const [removedUids, setRemovedUids] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const {
    handleChange,
    handlePosterSelect,
    handlePosterUpload,
    handlePosterChange,
    handleNewPosterChange,
    handleNewPosterRemove,
    handleUploadedPosterRemove,
  } = PosterHandlers({
    form,
    seasonId,
    selectedPoster,
    setNewPosterList,
    setUploadedPosterList,
    setSelectedPoster,
    removedUids,
    setRemovedUids,
  });

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const posterList = await seasonService.fetchPoster(Number(seasonId));
      const uploadedPosterList: PosterInterface[] = posterList.map((poster: PosterInterface) => {
        return {
          ...poster,
          state: THUMBNAIL_UPLOAD_STATE.UPLOADED,
          originFileObj: undefined,
        };
      });

      const selectedPoster = uploadedPosterList.find(
        (poster: PosterInterface) => poster.is_representative
      );
      form.setFieldValue('newPosterList', []);
      form.setFieldValue('uploadedPosterList', uploadedPosterList);
      form.setFieldValue('posterList', uploadedPosterList);
      setNewPosterList([]);
      setUploadedPosterList(uploadedPosterList);
      setSelectedPoster(selectedPoster || null);
    };
    fetchData().then(() => {
      setIsLoading(false);
    });
  }, [form]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="poster-container">
      <div style={{ display: 'flex' }}>
        <div className="poster-preview-container">
          <span> Selected Poster </span>
          <img src={selectedPoster ? selectedPoster.file : ''} alt="" className="poster-preview" />
        </div>
        <div style={{ width: '100%' }}>
          <div className="poster-uploaded-container">
            <Upload
              key={'upload-poster'}
              accept="image/*,.psd"
              multiple={true}
              showUploadList={false}
              beforeUpload={() => {
                return false; // 자동 업로드 방지
              }}
              onChange={handleChange}
              listType="text"
            >
              <Button icon={<UploadOutlined />} style={{ width: '100%', marginBottom: '10px' }}>
                {`Poster Upload`}
              </Button>
            </Upload>
            <PosterListComponent
              posters={newPosterList}
              selectedPoster={selectedPoster}
              onPosterSelect={handlePosterSelect}
              onPosterRemove={handleNewPosterRemove}
              onPosterChange={handlePosterChange}
              onNewPosterChange={handleNewPosterChange}
              isNew={true}
            />
          </div>
          <div className="Poster-uploaded-container">
            <PosterListComponent
              posters={uploadedPosterList}
              selectedPoster={selectedPoster}
              onPosterSelect={handlePosterSelect}
              onPosterRemove={handleUploadedPosterRemove}
              onPosterChange={handlePosterChange}
              onNewPosterChange={handleNewPosterChange}
              canDownload={true}
            />
          </div>
        </div>
      </div>
      <Form.Item style={{ marginTop: 16, textAlign: 'center' }}>
        <Button type="primary" onClick={() => handlePosterUpload()}>
          Save
        </Button>
      </Form.Item>
    </div>
  );
};

export default Poster;
